export class ClientBalanceResponse {
  balances: Map<string, number>
}
